/* eslint-disable jsx-a11y/anchor-is-valid */
import React from "react";
import { useNavigate } from "react-router-dom";
interface Link {
  label: string;
  path: string;
  active: boolean;
  icon?: string;
}
interface MenuItem {
  title: string;
  links: Link[];
}
const menuItems: MenuItem[] = [
  {
    title: "Features",
    links: [
      { label: "Launchpad", path: "/launchpads", active: true },
      { label: "Airdrop", path: "/airdrop", active: true },

      {
        label: "NFT",
        path: "/nft",
        active: true,
      },
      {
        label: "Gamehub",
        path: "https://gamehub.tinyblock.io/",
        active: true,
      },
    ],
  },
  {
    title: "Resources",
    links: [
      { label: "Docs", path: "https://docs.tinyblock.io", active: true },
      {
        label: "Media Kit",
        path: "https://drive.google.com/drive/folders/1DATfqAoOjYAnE5EXlebs2pDx54si5kKC",
        active: true,
      },
    ],
  },
  {
    title: "Services",
    links: [
      {
        label: "Apply for IDO",
        path: "https://forms.gle/rdL9JAQmq5EoV1AY9",
        active: true,
      },
      {
        label: "Apply for Airdrop",
        path: "https://forms.gle/ePpeVJPqkedQC5Fv9",
        active: true,
      },
      {
        label: "Apply for Gamehub",
        path: "https://forms.gle/W64kDFEjgNifFQq56",
        active: true,
      },
    ],
  },
  {
    title: "Legal",
    links: [
      { label: "Privacy Policy", path: "/privacy", active: true },
      { label: "Terms of Use", path: "/terms", active: true },
    ],
  },
];

const socialLinks: Link[] = [
  {
    label: "X",
    path: "https://x.com/TinyBlock_io",
    active: true,
    icon: "/images/s-x.png",
  },
  {
    label: "Telegram",
    path: "http://t.me/tinyblock_io",
    active: true,
    icon: "/images/s-t.png",
  },
  {
    label: "Discord",
    path: "https://discord.gg/M2TaS3ZQhY",
    active: true,
    icon: "/images/s-d.png",
  },
  {
    label: "YouTube",
    path: "https://www.youtube.com/@TinyBlock_io",
    active: true,
    icon: "/images/icon-social-youtube.svg",
  },
  {
    label: "Substack",
    path: "https://substack.com/@tinyblock",
    active: true,
    icon: "/images/icon-social-sub.svg",
  },
];

const Footer = () => {
  const navigate = useNavigate();

  const handleClick =
    (link: Link) => (e: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => {
      e.preventDefault();
      if (!link.active) return;
      window.open(
        link.path,
        link.path.startsWith("http") ? "_blank" : "_self",
        "noopener,noreferrer"
      );
    };

  return (
    <>
      <footer
        className="footer bg-no-repeat bg-contain 2xl:bg-cover md:bg-top w-full h-full
       pt-8 md:pt-10 xl:pt-14 font-Montserrat"
      >
        <div className="max-w-[1040px] mx-auto px-[5vw] lg:px-6">
          <div className="py-10 flex gap-8 sm:gap-5 flex-col sm:flex-row">
            <div className="w-full sm:w-[37%]">
              <div className="mb-5" onClick={() => navigate("/")}>
                <img
                  src="/images/logo.png"
                  alt=""
                  className="block w-[150px]"
                />
              </div>
              <p className="font-semibold text-xl mb-5 text-left whitespace-pre-wrap">
                TinyBlock -{" "}
                <span className="sm:max-md:visible hidden">{"\n"}</span>
                <span className="text-customBlue-500">
                  <span className="whitespace-nowrap">Fuel your Launch.</span>
                  {"\n"}
                  <span className="whitespace-nowrap">Fund your Future</span>
                </span>
              </p>
              <div className="flex items-center gap-4">
                {socialLinks.map((link, index) => (
                  <a
                    key={index}
                    href="#"
                    onClick={handleClick(link)}
                    target={
                      link.path.startsWith("http") && link.active
                        ? "_blank"
                        : undefined
                    }
                  >
                    <img
                      src={link.icon}
                      alt={link.label}
                      style={{ cursor: link.active ? "pointer" : "default" }}
                      className="!w-6 h-6 block"
                    />
                  </a>
                ))}
              </div>
            </div>
            <div className="w-full sm:w-[63%] text-left text-text-secondary">
              <div className="list-menu flex gap-3 flex-wrap">
                {menuItems.map((menu, index) => (
                  <div
                    key={index}
                    className="flex flex-col gap-4 w-[calc((100%-0.75rem)/2)] md:w-[calc((100%-2.25rem)/4)]"
                  >
                    <div className="font-bold text-base md:mb-3">
                      {menu.title}
                    </div>
                    {menu.links.map((link, linkIndex) => (
                      <a
                        key={linkIndex}
                        href="#"
                        onClick={handleClick(link)}
                        target={
                          link.path.startsWith("http") && link.active
                            ? "_blank"
                            : undefined
                        }
                        rel={
                          link.path.startsWith("http") && link.active
                            ? "noopener noreferrer"
                            : undefined
                        }
                        className="cursor-pointer font-medium text-base"
                      >
                        {link.label}
                      </a>
                    ))}
                  </div>
                ))}
              </div>
            </div>
          </div>
          <div className="py-6 text-left text-base text-text-secondary tracking-[0.65px]">
            © 2025 TinyBlock Ltd. All Rights Reserved.
          </div>
        </div>
      </footer>
    </>
  );
};

export default Footer;
